"use client"

import { ThemeProvider as NextThemesProvider } from "next-themes"

/**
 * next-themes provider.
 *
 * This lived inside app/layout.tsx as an extra named export. A layout module is
 * only allowed to export the segment API (`default`, `metadata`, `viewport`, …),
 * so exporting a component from it failed Next's generated route typecheck and
 * broke `next build` — dev mode never surfaced it.
 */
export function ThemeProvider({
  children,
  ...props
}: React.ComponentProps<typeof NextThemesProvider>) {
  return <NextThemesProvider {...props}>{children}</NextThemesProvider>
}
